import React from "react";
import { BasicInfo, BasicInfoSkeleton } from "./BasicInfo";
import { Col, Container, Row, Stack } from "react-bootstrap";
import {
  JobData,
  JobDataSkeleton,
  PermissionsData,
  PermissionsDataSkeleton,
} from "./Sections";

export const UserProfile = ({ loading, isError, user, id }) => {
  if (isError) return null;

  const basicInfo = {
    name_ar: user?.name_ar,
    name_en: user?.name_en,
    email: user?.email,
    phone: user?.phone,
    national_id: user?.national_id,
    nationality: user?.nationality,
    profile_image_url: user?.profile_image_url,
    gender: user?.gender,
  };
  const jobData = {
    job: user?.job,
    sector: user?.sector,
    department: user?.department,
    job_destination: user?.job_destination,
    service_center: user?.service_center,
  };
  const permissionsData = {
    systems: user?.systems,
    roles: user?.roles,
    groups: user?.groups,
  };

  return (
    <>
      <Container fluid className="mt-5">
        <Row>
          <Col xl={5} className="mb-4">
            {loading ? <BasicInfoSkeleton /> : <BasicInfo data={basicInfo} />}
          </Col>
          <Col xl={7}>
            <Stack gap={4}>
              {loading ? <JobDataSkeleton /> : <JobData data={jobData} />}
              {loading ? (
                <PermissionsDataSkeleton />
              ) : (
                <PermissionsData data={permissionsData} />
              )}
            </Stack>
          </Col>
        </Row>
      </Container>
    </>
  );
};
